import {
  useEffect,
  useState,
  useRef,
  forwardRef,
  useImperativeHandle,
} from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import { v4 as uuidv4 } from "uuid";
import { useWindowSize } from "../../../utils/useWindowSize";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";
import IconButton from "@mui/material/IconButton";
import BlockIcon from "@mui/icons-material/Block";
import CloseIcon from "@mui/icons-material/Close";
import MapsUgcIcon from "@mui/icons-material/MapsUgc";
import Divider from "@mui/material/Divider";
import Slider from "@mui/material/Slider";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import ModeIcon from "@mui/icons-material/Mode";
import Tooltip from "@mui/material/Tooltip";
import DownloadIcon from "@mui/icons-material/Download";
import PushPinIcon from "@mui/icons-material/PushPin";
import ForumIcon from "@mui/icons-material/Forum";
import HelpCenterIcon from "@mui/icons-material/HelpCenter";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";

import { ListChildComponentProps, VariableSizeList } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";

import { HttpAdminApi } from "../../../interface/admin-api";
import { HttpAdminIotApi } from "../../../interface/admin-iot-rest-api";
import { userState, appConfig } from "../../../interface/MainInterface";
import { CommonUtils } from "../../../utils/common_utils";
import * as ChatConstant from "./ChatConstant";

import ChatBlock from "./ChatBlock";
import ChatUpdate from "./ChatUpdate";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  Pagination,
  Stack,
  TextField,
} from "@mui/material";

import LoadingCircle from "../../../utils/LoadingCircle";
import { useInterval } from "../../../utils/UseInterval";

import "./LiveChatModule.css";
import dayjs from "dayjs";
import {
  DataGrid,
  GridColDef,
  gridPageCountSelector,
  gridPageSelector,
  GridPaginationModel,
  GridRenderCellParams,
  GridRowSelectionModel,
  useGridApiRef,
  useGridSelector,
} from "@mui/x-data-grid";
import ChatPrivate from "./ChatPrivate";
import NicknameUpdate from "./NicknameUpdate";
import Toast from "../../../utils/Toast";

interface propsType {
  channelInfo: any;
  userState: userState;
  sendIoTMessage: any;
  callback: any;
}

type ChatPayload = {
  topic: string;
  ChannelArn: string;
  Content: string;
  CreatedTimestamp: string;
  LastUpdatedTimestamp: string;
  MessageId: string;
  Persistence: string;
  Redacted: boolean;
  Sender: {
    Arn: string;
    Name: string;
  };
  Status: {
    Value: string;
  };
  Type: string;
  Receiver?: string;
};

type QnAMsgType = {
  pk: string;
  sk: string;
  aContent: string;
  aCreatedTimestamp: string;
  aUserId: string;
  aUserName: string;
  qContent: string;
  qCreatedTimestamp: string;
  qUserId: string;
  qUserName: string;
};

let quoteBoxCss = {
  position: "absolute",
  bottom: 0,
  width: "100%",
  flexGrow: 1,
  display: "flex",
  alignItems: "center",
};

interface chatSendForm {
  msg: string;
}

const pageSize: number = 100;

const adminApi = new HttpAdminApi();
const adminIotApi = new HttpAdminIotApi();

const LiveChatModule = (props: propsType, ref: any) => {
  const windowSize = useWindowSize();
  const cUtils = new CommonUtils();

  const [loading, setLoading] = useState(false);

  const toastRef: any = useRef();

  const gridApi = useGridApiRef();
  const inputChatRef: any = useRef();
  const inputMsgRef = useRef<any>();

  const privateInputChatRef: any = useRef();
  const privateInputMsgRef = useRef<any>();

  const chatInnerRef = useRef<HTMLDivElement>();
  const listRef = useRef<any>(null); // Ref for chatting list
  const rowHeights = useRef<any>({}); // Array for set dynamic height foreach message contents

  const privateListRef = useRef<any>(null); // Ref for private chatting list

  const [chatInit, setChatInit] = useState(false);
  const [messages, setMessages] = useState<any>([]);
  const [privateMessages, setPrivateMessages] = useState<any>([]);
  const [nextToken, setNextToken] = useState(undefined);
  const [needScrollEnd, setNeedScrollEnd] = useState<Boolean>(true);
  const [btnNewMsgBoxStyle, setBtnNewMsgBoxStyle] = useState({
    display: "none",
  });
  const [managerCampaignText, setManagerCampaignText] = useState("");
  const [visibleStartIndex, setVisibleStartIndex] = useState(0);

  const [openChatUserList, setOpenChatUserList] = useState(false);
  const [openQnAList, setOpenQnAList] = useState(false);
  const [totalChatUserList, setTotalChatUserList] = useState<any>([]);
  const [chatUserList, setChatUserList] = useState<any>([]);
  const [broadQnaList, setBroadQnaList] = useState<QnAMsgType[]>([]);

  const [selectedId, setSelectedId] = useState("");
  const [searchId, setSearchId] = useState("");
  const [quotePrivateMsg, setQuotePrivateMsg] = useState(false);

  const [nickname, setNickname] = useState(props.userState.name);
  const [nicknameChange, setNicknameChange] = useState(false);

  // Ref for subscribe callback
  const messagesRef = useRef(messages);
  const chatBlockRef: any = useRef();
  const chatUpdateRef: any = useRef();

  const [quoteText, setQuoteText] = useState("");
  const [qMessageId, setQMessageId] = useState("");

  const [fontSize, setFontSize] = useState<number | Array<number> | undefined>(
    1.0
  );

  const [pool, setPool] = useState(false);

  const [pinMsgId, setPinMsgId] = useState("");

  const gridHeight = 608;
  const [selectedRow, setSelectedRow] = useState<GridRowSelectionModel>([]);
  const [selectedPage, setSelectedPage] = useState<GridPaginationModel>({
    pageSize: pageSize,
    page: 0,
  });

  const columns: GridColDef[] = [
    {
      field: "userId",
      headerName: "아이디",
      width: 120,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "nickname",
      headerName: "닉네임",
      width: 140,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "enter_time_stamp",
      headerName: "입장시간",
      width: 150,
      headerAlign: "center",
      align: "center",
      renderCell: (param: GridRenderCellParams) => {
        return (
          <>
            <span>
              {dayjs(param.row.enter_time_stamp).format("YYYY-MM-DD HH:mm:ss")}
            </span>
          </>
        );
      },
    },
  ];

  function CustomPagination() {
    const page = useGridSelector(gridApi, gridPageSelector);
    const pageCount = useGridSelector(gridApi, gridPageCountSelector);
    return (
      <Box className="tenants-list-pagenation">
        <Pagination
          color="primary"
          shape="rounded"
          count={pageCount === 0 ? 1 : pageCount}
          page={page + 1}
          siblingCount={10}
          onChange={(e, v) => gridApi.current.setPage(v - 1)}
        ></Pagination>
      </Box>
    );
  }

  useEffect(() => {
    if (windowSize.width < 768) {
      setFontSize(0.7);
    }
    getAdminNickname();
    getChatUserList();
    getBroadQnaList();
    return () => {
      // 메모리 누수를 방지하기 위해서 컴포넌트 언마운트시 State를 초기화 한다.
      setMessages([]);
      setPrivateMessages([]);
      setNextToken(undefined);
      setNeedScrollEnd(true);
      setBtnNewMsgBoxStyle({ display: "none" });
      setManagerCampaignText("");
      setVisibleStartIndex(0);
      setQuoteText("");
      setQMessageId("");
      setFontSize(1.0);
      setLoading(false);
      setPool(false);
      setPinMsgId("");
    };
  }, []);

  // subscript callback 연동용 Ref 최신화
  useEffect(() => {
    messagesRef.current = messages;
  });

  // 관리자 이벤트 수신시 Toast 메세지를 띄우주기
  useEffect(() => {
    if (managerCampaignText !== "") {
      setTimeout(() => {
        setManagerCampaignText("");
      }, 2000);
    }
  }, [managerCampaignText]);

  // 채팅창 스크롤 제일 아래로 이벤트 처리
  useEffect(() => {
    if (messages.length > 0) {
      if (needScrollEnd) {
        setBtnNewMsgBoxStyle({ display: "none" });
        scrollToBottom();
      } else {
        //if (!props.hidden_menu)
        setBtnNewMsgBoxStyle({ display: "inline" });
      }
    }
  }, [messages, needScrollEnd]);

  useEffect(() => {
    if (privateMessages.length > 0) {
      scrollToBottomPrivate();
    }
  }, [privateMessages]);

  const getAdminNickname = async () => {
    const adminCookieId = window.localStorage.getItem("ezwelAdminTempId");
    if (
      adminCookieId !== undefined &&
      adminCookieId !== "" &&
      adminCookieId !== null
    ) {
      const param = {
        command: "get_admin_nickname",
        userId: props.userState.id,
        tempId: adminCookieId,
      };
      const result = await adminApi.post(param);
      if (result.code === "200") {
        const usedNickname = result.response.nickname;
        if (usedNickname !== "") setNickname(usedNickname);
        else {
          const set_nickname_param = {
            command: "set_admin_nickname",
            userId: props.userState.id,
            tempId: adminCookieId,
            nickname: props.userState.name,
          };
          const set_nickname_result = await adminApi.post(set_nickname_param);
          if (set_nickname_result.code === "200") {
            const newNickname = set_nickname_result.response.nickname;
            setNickname(newNickname);
          } else {
            setNickname(props.userState.name);
          }
        }
      } else {
        setNickname(props.userState.name);
      }
    } else {
      const tempAdminId = uuidv4();
      window.localStorage.setItem("ezwelAdminTempId", tempAdminId);

      const param = {
        command: "set_admin_nickname",
        userId: props.userState.id,
        tempId: tempAdminId,
        nickname: props.userState.name,
      };
      const result = await adminApi.post(param);
      if (result.code === "200") {
        const newNickname = result.response.nickname;
        if (newNickname !== "") {
          setNickname(newNickname);
        } else {
          setNickname(props.userState.name);
        }
      } else {
        setNickname(props.userState.name);
      }
    }
  };

  const changeAdminNickname = async (newNickname: string) => {
    const adminCookieId = window.localStorage.getItem("ezwelAdminTempId");
    if (
      adminCookieId !== undefined &&
      adminCookieId !== "" &&
      adminCookieId !== null
    ) {
      const param = {
        command: "set_admin_nickname",
        userId: props.userState.id,
        tempId: adminCookieId,
        nickname: newNickname,
      };
      const result = await adminApi.post(param);
      if (result.code === "200") {
        const newNickname = result.response.nickname;
        if (newNickname !== "") {
          toastRef.current?.toast("닉네임 변경 성공", "success", 3000, {
            vertical: "top",
            horizontal: "center",
          });
          setNickname(newNickname);
        } else {
          toastRef.current?.toast(
            "닉네임 변경 실패, 잠시 후 이용해주세요.",
            "error",
            3000,
            {
              vertical: "top",
              horizontal: "center",
            }
          );
          setNickname(props.userState.name);
        }
      } else {
        toastRef.current?.toast(
          "닉네임 변경 실패, 잠시 후 이용해주세요.",
          "error",
          3000,
          {
            vertical: "top",
            horizontal: "center",
          }
        );
        setNickname(props.userState.name);
      }
    } else {
      toastRef.current?.toast(
        "닉네임 변경 실패, 새로고침 후 다시 이용해주세요.",
        "error",
        3000,
        {
          vertical: "top",
          horizontal: "center",
        }
      );
    }
  };

  // 최초 채널 입장시 기존 차임 메시지 조회(현재 최대 50건)
  const getListChannelMessages = async (channelArn: string) => {
    if (channelArn === undefined) return;
    const param: any = {
      command: "list_chat_history",
      channel_arn: channelArn,
      next_token: nextToken,
      list_mode: appConfig.listChannelMode,
      broad_seq: props.channelInfo.broad_seq,
    };

    await adminApi.post(param).then((result: any) => {
      if (result.code === "200") {
        setMessages(result.response.chat_history.Messages);
        setChatInit(true);
        const pinMessages: any = result.response.pin_messages;
        if (pinMessages.length > 0) {
          setPinMsgId(pinMessages[pinMessages.length - 1].message_id);
        }
      }
    });
  };

  const pollChannelMessages = async (channel_arn: string) => {
    // console.log("11");
    const param: any = {
      command: "list_chat_limit_history",
      channel_arn: channel_arn,
      next_token: nextToken,
      list_mode: appConfig.listChannelMode,
      limit: 30,
      broad_seq: props.channelInfo.broad_seq,
    };

    await adminApi.post(param).then((result: any) => {
      if (result.code === "200") {
        for (const msg of result.response.chat_history.Messages) {
          msg.ChannelArn = channel_arn;
          processChannelMessage(msg);
        }
        const pinMessages: any = result.response.pin_messages;
        if (pinMessages.length > 0) {
          setPinMsgId(pinMessages[pinMessages.length - 1].message_id);
        }
      }
    });
  };

  const getChatUserList = async () => {
    const param = {
      command: "get_chat_user_list",
      broad_seq: props.channelInfo.broad_seq,
    };
    await adminApi.post(param).then((result: any) => {
      if (result.code === "200") {
        setTotalChatUserList(
          result.response.chat_user_list.filter(
            (userInfo: any) => userInfo.userId !== props.userState.id
          )
        );
        setChatUserList(
          result.response.chat_user_list.filter(
            (userInfo: any) => userInfo.userId !== props.userState.id
          )
        );
      }
    });
  };

  // 방송 Q&A List 조회
  const getBroadQnaList = async () => {
    try {
      const param = {
        command: "list_broad_qna",
        broad_seq: props.channelInfo.broad_seq,
        sort: "DESCEND",
      };
      const broadQnaResult = await adminApi.post(param);
      if (broadQnaResult.code === "200") {
        setBroadQnaList(broadQnaResult.response.qna_list);
      } else {
        console.error(broadQnaResult.response.error_msg);
      }
    } catch (error) {
      console.error("getBroadQnaList: ", error);
    }
  };

  const delayPool: number = 2000; // 2초마다 변경
  useInterval(
    () => {
      pollChannelMessages(props.channelInfo.chime_channel_arn);
    },
    pool ? delayPool : null
  );

  useEffect(() => {
    if (
      props.channelInfo?.broad_status === "STOP" ||
      props.channelInfo?.broad_status === "CREATE" ||
      props.channelInfo?.broad_status === "VOD"
    ) {
      setPool(false);
      setTimeout(() => {
        setNeedScrollEnd(true);
        setBtnNewMsgBoxStyle({ display: "none" }); // 최신메세지 버튼
      }, 500);
    } else {
      if (chatInit) {
        setTimeout(() => {
          setNeedScrollEnd(true);
          setBtnNewMsgBoxStyle({ display: "none" }); // 최신메세지 버튼
          setPool(true);
        }, 500);
      } else setPool(false);
    }
  }, [props.channelInfo, chatInit]);

  // 차임 메시지 도착(실시간)시 처리용 프로세스
  const processChannelMessage = async (message: any) => {
    const promise = Promise.resolve(message);
    const newMessage = await promise.then((m) => m);

    if (newMessage.ChannelArn !== props.channelInfo.chime_channel_arn) return;
    let isDuplicate = false;
    messagesRef.current?.forEach((m: any, i: number, self: any) => {
      if ((m.response?.MessageId || m.MessageId) === newMessage.MessageId) {
        isDuplicate = true;
        self[i] = newMessage;
      }
    });

    let newMessages: any = [...messagesRef.current];
    if (
      !isDuplicate &&
      newMessage.Persistence === ChatConstant.Persistence.PERSISTENT
    ) {
      newMessages = [...newMessages, newMessage];
      setMessages(newMessages);
    }

    if (
      !isDuplicate &&
      (newMessage.Sender.Arn === selectedId ||
        (newMessage.Type === "PRIVATE" && newMessage.Receiver === selectedId))
    ) {
      setPrivateMessages([...privateMessages, newMessage]);
    }
  };

  const processUserEnter = async (userInfo: any) => {
    const promise = Promise.resolve(userInfo);
    const newMessage = await promise.then((m) => m);

    if (newMessage.topic === "chat/enter") {
      const newUser = {
        userId: newMessage.userId,
        nickname: newMessage.nickname,
        enter_time_stamp: newMessage.enter_time_stamp,
      };
      if (newUser.userId !== props.userState.id) {
        setTotalChatUserList([...chatUserList, newUser]);
        setChatUserList([...chatUserList, newUser]);
      }
    } else if (newMessage.topic === "chat/exit") {
      const userId = newMessage.userId;
      setTotalChatUserList(
        chatUserList.filter((user: any) => user.userId !== userId)
      );
      setChatUserList(
        chatUserList.filter((user: any) => user.userId !== userId)
      );
    } else if (newMessage.topic === "chat/changeNickname") {
      const userId = newMessage.userId;

      let tmpChatUserList = [...totalChatUserList];
      for (let chatUser of tmpChatUserList) {
        if (chatUser.userId === userId) {
          chatUser.nickname = newMessage.nickname;
          break;
        }
      }
      setTotalChatUserList(tmpChatUserList);
      setChatUserList(tmpChatUserList);
    }
  };

  const fncQuote = (msg: any) => {
    setQuoteText(`(${msg.Sender.Name}) ${msg.Content}`);
    setQMessageId(msg.MessageId);
    inputMsgRef.current?.focus();
  };

  const fncQuoteOnly = (msg: any) => {
    setQuoteText(`(${msg.Sender.Name}) ${msg.Content}`);
    setQMessageId("");
    inputMsgRef.current?.focus();
  };

  const fncPrivate = (msg: any) => {
    setSelectedId(msg.Sender.Arn);
    setQuotePrivateMsg(true);
    setQuoteText(`(${msg.Sender.Name}) ${msg.Content}`);
    setQMessageId("");
    inputMsgRef.current?.focus();
  };

  const fncBlock = async (message: any) => {
    // Speed Dial open
    chatBlockRef.current?.open(message);
  };

  const fncChatUpdate = async (msg: any) => {
    console.log("update msg : ", msg);
    chatUpdateRef.current?.open(msg);
  };

  const fncResetQuote = () => {
    setSelectedId((beforeId) => "");
    setQuotePrivateMsg(false);
    setQuoteText((quoteText) => "");
    setQMessageId((qMessageId) => "");
  };

  const resetMessages = async () => {
    if (window.confirm("채팅 메세지를 모두 삭제하시겠습니까?")) {
      setLoading(true);
      const param: any = {
        command: "delete_chat_history",
        channel_arn: props.channelInfo.chime_channel_arn,
        broad_seq: props.channelInfo.broad_seq,
      };
      await adminApi.post(param);
      setLoading(false);
      window.location.reload();
    }
  };

  const downloadMessages = async () => {
    // sheet header
    let chatHistory: any = [["순번", "채팅일시", "작성자", "내용"]];
    // 각 행 순번 만들기
    let chatIndex = 1;
    // 내용 생성
    for (const message of messages) {
      const detail = [
        chatIndex,
        dayjs(String(message.CreatedTimestamp)).format("YYYY-MM-DD HH:mm:ss"),
        message.Sender.Name,
        message.Content,
      ];
      chatHistory = [...chatHistory, detail];
      chatIndex += 1;
    }
    // 컬럼 넓이
    const colWidth = [{ wpx: 40 }, { wpx: 150 }, { wpx: 130 }, { wpx: 800 }];
    const sheetName = "채팅내역";
    // 파일명
    const fileName =
      dayjs(String(props.channelInfo.broad_start_tm)).format(
        "YYYY-MM-DD HHmm"
      ) +
      "_채팅_" +
      props.channelInfo.broad_title +
      ".xlsx";
    cUtils.downloadExcel(chatHistory, colWidth, sheetName, fileName);
  };

  const fncUpdate = async (msg: any) => {
    setLoading(true);
    let updateParam: any = msg;
    updateParam.command = "update_chat_history";
    updateParam.broad_seq = props.channelInfo.broad_seq;

    await adminApi.post(updateParam);
    const topic = `live/${props.channelInfo.broad_seq}/payload`;
    let chatPayload: ChatPayload = {
      topic: "chat/message",
      ChannelArn: props.channelInfo.chime_channel_arn,
      Content: msg.Content,
      CreatedTimestamp: msg.CreatedTimestamp,
      LastUpdatedTimestamp: "",
      MessageId: msg.MessageId,
      Persistence: "PERSISTENT",
      Redacted: false,
      Sender: {
        Arn: props.channelInfo.chime_admin_arn,
        Name: props.userState.name,
      },
      Status: {
        Value: "SENT",
      },
      Type: msg.Type,
    };
    if (msg.Type === "PRIVATE") {
      chatPayload = {
        ...chatPayload,
        Receiver: msg.Receiver,
      };
    }
    // 채팅 금지 확인 필요
    const param: any = {
      topic: topic,
      payload: chatPayload,
    };

    await adminIotApi.send_iot_message(param);
    setLoading(false);

    setNeedScrollEnd(true);
    setBtnNewMsgBoxStyle({ display: "none" }); // 최신메세지 버튼
  };

  // 채팅 메시지 전송
  const sendMessage = async (msg: string, meta: string) => {
    if (quotePrivateMsg) {
      sendPrivateMessage(msg, selectedId);
      return;
    }
    const origin_msg = msg;
    const qMsgId = qMessageId;
    // 답글이 있으면 답글을 신규 컨텐츠에 추가
    if (quoteText !== "") {
      msg = quoteText + appConfig.quote_separator + msg;
    }
    fncResetQuote();

    const msgId = uuidv4();
    const topic = `live/${props.channelInfo.broad_seq}/payload`;
    const chatPayload = {
      command: "send_chat_history",
      topic: "chat/message",
      ChannelArn: props.channelInfo.chime_channel_arn,
      Content: msg,
      CreatedTimestamp: "",
      LastUpdatedTimestamp: "",
      MessageId: msgId,
      Persistence: "PERSISTENT",
      Redacted: false,
      Sender: {
        Arn: props.channelInfo.chime_admin_arn,
        Name: nickname,
      },
      Status: {
        Value: "SENT",
      },
      Type: "STANDARD",
    };
    // 채팅 금지 확인 필요
    const param: any = {
      topic: topic,
      payload: chatPayload,
    };

    adminIotApi.send_iot_message(param);
    await adminApi.post(chatPayload);
    if (quoteText !== "" && qMsgId !== "") {
      const qnaParam: any = {
        command: "send_qna_message",
        message_info: {
          broad_seq: props.channelInfo.broad_seq,
          channel_arn: props.channelInfo.chime_channel_arn,
          q_message_id: qMsgId,
          a_message_id: msgId,
          origin_msg: origin_msg,
          user_id: props.channelInfo.chime_admin_arn,
        },
      };
      const resultQna = await adminApi.post(qnaParam);
      props.sendIoTMessage({
        topic: "live/metadata",
        message: "qna",
        q: resultQna.response.q_message_info.content,
        qSender: resultQna.response.q_message_info.nick_name,
        a: origin_msg,
        aSender: resultQna.response.a_message_info.nick_name,
      });
    }

    setNeedScrollEnd(true);
    setBtnNewMsgBoxStyle({ display: "none" }); // 최신메세지 버튼
  };

  // 채팅 메시지 전송
  const sendPrivateMessage = async (msg: string, receiverId: string) => {
    // 답글이 있으면 답글을 신규 컨텐츠에 추가
    if (quoteText !== "") {
      msg = quoteText + appConfig.quote_separator + msg;
    }
    if (quotePrivateMsg) {
      fncResetQuote();
    }

    if (receiverId === "") {
      console.error("private message failed");
      return;
    }

    const msgId = uuidv4();
    const topic = `live/${props.channelInfo.broad_seq}/payload`;
    const chatPayload = {
      command: "send_chat_history",
      topic: "chat/message",
      ChannelArn: props.channelInfo.chime_channel_arn,
      Content: msg,
      CreatedTimestamp: dayjs().format("YYYYMMDDHHmmss"),
      LastUpdatedTimestamp: "",
      MessageId: msgId,
      Persistence: "PERSISTENT",
      Redacted: false,
      Sender: {
        Arn: props.channelInfo.chime_admin_arn,
        Name: props.userState.name,
      },
      Status: {
        Value: "SENT",
      },
      Type: "PRIVATE",
      Receiver: receiverId,
    };

    const param: any = {
      topic: topic,
      payload: chatPayload,
    };

    adminIotApi.send_iot_message(param);
    await adminApi.post(chatPayload);
  };

  const deleteQnaMessage = async (sk: string) => {
    if (!window.confirm("Q&A를 삭제하시겠습니까?")) return;

    try {
      const param = {
        command: "delete_qna_message",
        broad_seq: props.channelInfo.broad_seq,
        sk: sk,
      };

      const result = await adminApi.post(param);
      if (result.code === "200") {
        // getBroadQnaList();
        setBroadQnaList((prevBroadQnaList) =>
          prevBroadQnaList.filter((qna) => qna.sk !== sk)
        );
        props.sendIoTMessage({
          topic: "live/metadata",
          message: "qnaDelete",
          sk: sk,
        });
      } else {
        window.alert("Q&A 삭제에 실패하였습니다. 잠시 후 이용해주세요.");
      }
    } catch (error) {
      console.error(error);
    }
  };

  // 채팅 고정
  const put_pin_message = async (msgInfo: any) => {
    const param: any = {
      command: "put_pin_message",
      broad_seq: props.channelInfo.broad_seq,
    };

    if (pinMsgId === msgInfo.MessageId) {
      param.message_id = "";
      param.message = "";
    } else {
      param.message_id = msgInfo.MessageId;
      param.message = msgInfo.Content;
    }

    setLoading(true);
    const res = await adminApi.post(param);
    if (res.code === "200") {
      props.sendIoTMessage({
        topic: "live/metadata",
        message: "pin_message",
        id: param.message_id,
        text: param.message,
      });
      setPinMsgId(param.message_id);
    }
    setLoading(false);
  };

  // 채팅창 ListItem의 높이를 동적 처리하기 위한 기능
  function getRowHeight(index: number) {
    return rowHeights.current[index] + 8 || 36;
  }

  // 각 row별 높이를 저장하기 위한 기능
  function setRowHeight(index: any, size: any) {
    listRef.current?.resetAfterIndex(0);
    rowHeights.current = { ...rowHeights.current, [index]: size };
  }

  // 채팅 메시지별 Row 그리는 기능(동적 높이 구현을 위한 기능 포함)
  function RenderRow(listProps: ListChildComponentProps) {
    const { index, style } = listProps;
    const newStyle = {
      left: "0px",
      height: style.height,
      width: "100%",
    };

    const rowRef = useRef<any>({});

    useEffect(() => {
      if (rowRef.current) {
        setRowHeight(index, rowRef.current?.clientHeight);
      }
    }, [rowRef]);

    return (
      <ListItem
        sx={{ padding: "8px 20px", userSelect: "text" }}
        style={visibleStartIndex > 0 ? style : newStyle}
        key={index}
      >
        <ListItemText
          primary={
            <Typography ref={rowRef} component="div" className="chat-list-body">
              <Box
                sx={{
                  width: "100%",
                  color: "black",
                  display: "inline-flex",
                  fontSize: fontSize + "rem",
                  ...(messages[index].Sender.Arn ===
                  props.channelInfo.chime_admin_arn
                    ? { justifyContent: "flex-end" }
                    : { justifyContent: "flex-start" }),
                }}
              >
                <Stack direction="column" spacing={1}>
                  {messages[index].Sender.Arn !==
                    props.channelInfo.chime_admin_arn &&
                    (messages[index].Sender.Name !==
                      messages[index - 1]?.Sender.Name ||
                      messages[index].Sender.Arn !==
                        messages[index - 1]?.Sender.Arn) && (
                      <span
                        style={{
                          maxWidth: "10rem",
                          display: "inline-block",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                        }}
                      >
                        {cUtils.maskingChar(messages[index].Sender.Name)}
                      </span>
                    )}
                  <Stack direction="row" spacing={1}>
                    {messages[index].Sender.Arn ===
                      props.channelInfo.chime_admin_arn &&
                      props.channelInfo.broad_status !== "VOD" &&
                      props.channelInfo.broad_status !== "STOP" && (
                        <Stack
                          direction="row"
                          spacing={1}
                          sx={{ justifyContent: "flex-start" }}
                        >
                          {messages[index].Type !== "PRIVATE" ? (
                            <div
                              style={{
                                alignSelf: "center",
                                marginLeft: "10px",
                              }}
                            >
                              <Tooltip title="라이브 공지사항">
                                <IconButton
                                  sx={{ padding: 0 }}
                                  onClick={() =>
                                    put_pin_message(messages[index])
                                  }
                                >
                                  <PushPinIcon
                                    sx={
                                      pinMsgId === messages[index].MessageId
                                        ? { color: "red" }
                                        : { color: "gray" }
                                    }
                                  />
                                </IconButton>
                              </Tooltip>
                            </div>
                          ) : (
                            <></>
                          )}
                          <div
                            style={{ alignSelf: "center", marginLeft: "10px" }}
                          >
                            <Tooltip title="채팅수정">
                              <IconButton
                                sx={{ padding: 0 }}
                                onClick={() => fncChatUpdate(messages[index])}
                              >
                                <ModeIcon sx={{ color: "black" }} />
                              </IconButton>
                            </Tooltip>
                          </div>
                        </Stack>
                      )}
                    <div
                      className={
                        messages[index].Sender.Arn ===
                        props.channelInfo.chime_admin_arn
                          ? messages[index].Type === "PRIVATE"
                            ? "speech-bubble-private"
                            : "speech-bubble-me"
                          : "speech-bubble"
                      }
                    >
                      {messages[index].Content.split(
                        appConfig.quote_separator
                      ).map((line: string, idx: number) => {
                        const repleLength = messages[index].Content.split(
                          appConfig.quote_separator
                        ).length;
                        let styleCss: any = {
                          wordBreak: "break-all",
                          whiteSpace: "pre-line",
                        };
                        if (idx !== repleLength - 1) styleCss.color = "#999999";
                        if (idx === 0) {
                          if (
                            messages[index].Metadata !== undefined &&
                            messages[index].Metadata === "chat_blocked"
                          ) {
                            styleCss.color = "cadetblue";
                            // 차단된 메세지
                            return (
                              <del key={index} style={styleCss}>
                                {"[차단]"}
                                {line}
                              </del>
                            );
                          } else {
                            return (
                              <span key={index} style={styleCss}>
                                {line}
                              </span>
                            );
                          }
                        } else {
                          styleCss.color = "#59f4f4";
                          return (
                            <span key={index + "-" + idx} style={styleCss}>
                              <Divider sx={{ borderColor: "#fff" }} />
                              {appConfig.quote_separator + " " + line}
                            </span>
                          );
                        }
                      })}
                    </div>
                    {messages[index].Metadata !== undefined &&
                    messages[index].Metadata === "chat_blocked" ? (
                      <></>
                    ) : (
                      messages[index].Sender.Arn !==
                        props.channelInfo.chime_admin_arn &&
                      props.channelInfo.broad_status !== "VOD" &&
                      props.channelInfo.broad_status !== "STOP" && (
                        <Stack
                          direction="row"
                          spacing={1}
                          sx={{ justifyContent: "flex-end" }}
                        >
                          <div
                            style={{ alignSelf: "center", marginLeft: "10px" }}
                          >
                            <Tooltip title="Q&A답글">
                              <IconButton
                                sx={{ padding: 0 }}
                                onClick={() => fncQuote(messages[index])}
                              >
                                <MapsUgcIcon sx={{ color: "black" }} />
                              </IconButton>
                            </Tooltip>
                          </div>
                          <div
                            style={{ alignSelf: "center", marginLeft: "10px" }}
                          >
                            <Tooltip title="단순답글">
                              <IconButton
                                sx={{ padding: 0 }}
                                onClick={() => fncQuoteOnly(messages[index])}
                              >
                                <MapsUgcIcon sx={{ color: "#00000080" }} />
                              </IconButton>
                            </Tooltip>
                          </div>
                          <div
                            style={{ alignSelf: "center", marginLeft: "10px" }}
                          >
                            <Tooltip title="귓속말">
                              <IconButton
                                sx={{ padding: 0 }}
                                onClick={() => fncPrivate(messages[index])}
                              >
                                <MapsUgcIcon sx={{ color: "#FFDCCC" }} />
                              </IconButton>
                            </Tooltip>
                          </div>
                          <div
                            style={{ alignSelf: "center", marginLeft: "10px" }}
                          >
                            <Tooltip title="채팅차단">
                              <IconButton
                                sx={{ padding: 0 }}
                                onClick={() => fncBlock(messages[index])}
                              >
                                <BlockIcon sx={{ color: "red" }} />
                              </IconButton>
                            </Tooltip>
                          </div>
                        </Stack>
                      )
                    )}
                  </Stack>
                </Stack>
              </Box>
            </Typography>
          }
        />
      </ListItem>
    );
  }

  // 스크롤에 따라서 최신 메시지, 스크롤 자동 하단 등 처리를 위한 이벤트
  const evtItemRendered = (e: any) => {
    if (chatInnerRef.current) chatInnerRef.current.style.marginTop = "auto";
    setVisibleStartIndex((visibleStartIndex) => e?.visibleStartIndex);
    if (e?.visibleStopIndex > 0 && messages.length > 0) {
      if (e.visibleStopIndex >= messages.length - 1) {
        setNeedScrollEnd(true);
        setBtnNewMsgBoxStyle({ display: "none" });
      } else {
        setNeedScrollEnd(false);
      }
    }
  };

  // 채팅창 내용 업데이트시 스크롤을 제일 아래로
  const scrollToBottom = () => {
    if (messages.length > 0) {
      listRef?.current?.scrollToItem(messages.length, "end");
    }
  };

  const scrollToBottomPrivate = () => {
    if (privateMessages.length > 0 && privateListRef.current) {
      privateListRef.current.scrollTop = privateListRef.current.scrollHeight;
    }
  };

  const callbackChatBlock = () => {};

  const handleTemperatureChange = (e: Event, newValue: number | number[]) => {
    setFontSize(newValue);
  };

  const handleRowSelected = (rowUserId: string) => {
    setSelectedId(rowUserId);
    if (rowUserId === "") {
      setPrivateMessages([]);
    } else {
      setPrivateMessages(
        messages.filter(
          (message: any) =>
            message.Sender.Arn === rowUserId ||
            (message.Type === "PRIVATE" && message.Receiver === rowUserId)
        )
      );
    }
  };

  useEffect(() => {
    if (props.channelInfo.chime_channel_arn !== "") {
      setTimeout(() => {
        getListChannelMessages(props.channelInfo.chime_channel_arn);
      }, 500);
    }
  }, [props.channelInfo.chime_channel_arn]);

  // 부모 Component에서 접근 가능하도록 함수 전달.
  useImperativeHandle(ref, () => ({
    sendMessage,
    scrollToBottom,
    fncResetQuote,
    resetMessages,
    processChannelMessage,
    processUserEnter,
  }));

  // Form for send message to chime channel
  const {
    register,
    setFocus,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm<chatSendForm>();

  // 채팅 메시지 전송버튼 클릭
  const onSubmit: SubmitHandler<chatSendForm> = async (data) => {
    inputMsgRef.current.focus();
    reset({ msg: "" });
    await sendMessage(data.msg, "");
  };

  const {
    register: privateRegister,
    setFocus: privateSetFocus,
    formState: privateFormState,
    handleSubmit: privateHandleSubmit,
    reset: privateReset,
  } = useForm<chatSendForm>();

  // 채팅 메시지 전송버튼 클릭
  const onPrivateSubmit: SubmitHandler<chatSendForm> = async (data) => {
    privateInputMsgRef.current.focus();
    privateReset({ msg: "" });
    await sendPrivateMessage(data.msg, selectedId);
  };

  const AutoLink = (prop: any) => {
    const delimiter = /(https?:\/\/[^\s]+)/g;
    return (
      <>
        {prop.text.split(delimiter).map((word: any, index: number) => {
          const match = word.match(delimiter);
          if (match) {
            const url = match[0];
            return (
              <a
                key={`a-t-k-${index}`}
                style={{ textDecoration: "underline", color: "#FF376D" }}
                target="_blank"
                href={url.startsWith("http") ? url : `http://${url}`}
                rel="noreferrer"
              >
                {url}
              </a>
            );
          }
          return word;
        })}
      </>
    );
  };

  return (
    <>
      <Box
        id="admin-chat-root"
        component="div"
        sx={
          /* 메인화면에서 비디오영역 클릭시 메뉴 감추기 */
          {
            height: "100%",
            width: "100%",
          }
        }
        className="admin-chat-root"
      >
        <Stack
          direction={"column"}
          spacing={0}
          sx={{ width: "100%", height: "100%" }}
        >
          <Box sx={{ pl: 2, pr: 2, pt: 1, pb: 1 }}>
            <Stack
              direction={windowSize.width > 768 ? "row" : "column"}
              spacing={2}
              sx={{ width: "100%", justifyContent: "space-between" }}
            >
              <Stack direction={"row"} spacing={2}>
                <Button
                  variant="contained"
                  color="error"
                  size={windowSize.width > 768 ? "medium" : "small"}
                  onClick={() => resetMessages()}
                  startIcon={<DeleteForeverIcon />}
                >
                  채팅삭제
                </Button>
                <Button
                  variant="outlined"
                  color="primary"
                  size={windowSize.width > 768 ? "medium" : "small"}
                  onClick={() => downloadMessages()}
                  startIcon={<DownloadIcon />}
                >
                  채팅 다운로드
                </Button>
                <Button
                  variant="outlined"
                  color="info"
                  size={windowSize.width > 768 ? "medium" : "small"}
                  onClick={() => setOpenChatUserList(true)}
                  startIcon={<ForumIcon />}
                >
                  회원 접속자
                </Button>
                <Button
                  variant="outlined"
                  color="inherit"
                  size={windowSize.width > 768 ? "medium" : "small"}
                  onClick={() => {
                    setOpenQnAList(true);
                    getBroadQnaList();
                  }}
                  startIcon={<HelpCenterIcon />}
                >
                  Q&A 목록
                </Button>
              </Stack>
              {windowSize.width > 768 && (
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Slider
                    value={fontSize}
                    onChange={handleTemperatureChange}
                    valueLabelDisplay="auto"
                    step={0.5}
                    min={1.0}
                    max={3.0}
                    sx={{ width: "100px" }}
                  />
                </Box>
              )}
            </Stack>
          </Box>
          <Divider />
          {/* 체팅창 영역 */}
          <Box
            component="div"
            sx={{
              width: "100%",
              height: "100%",
              position: "relative",
            }}
          >
            <Box sx={{ height: "100%", width: "100%" }}>
              <AutoSizer style={{ height: "100%", width: "100%" }}>
                {({ ...props }) => (
                  <VariableSizeList
                    height={props.height}
                    width={props.width}
                    itemSize={getRowHeight}
                    itemCount={messages.length}
                    overscanCount={5}
                    className="admin-chat-list"
                    innerRef={chatInnerRef}
                    ref={listRef}
                    onItemsRendered={evtItemRendered}
                  >
                    {RenderRow}
                  </VariableSizeList>
                )}
              </AutoSizer>
              {quoteText !== "" && (
                <Box className="quote-Container" sx={quoteBoxCss}>
                  <div style={{ flexGrow: 1 }}>{quoteText}</div>
                  <IconButton sx={{ padding: 0 }} onClick={fncResetQuote}>
                    <CloseIcon className="color-snow" />
                  </IconButton>
                </Box>
              )}
            </Box>

            {/* 체팅창 스크롤 위로갈때 스크롤 아래로 이동하는 버튼 */}
            <Box className="btn-admin-new-chat" sx={btnNewMsgBoxStyle}>
              <Button
                sx={{
                  backgroundColor: "#ff376d",
                  "&:hover": { backgroundColor: "#ff376d" },
                }}
                variant="contained"
                size="small"
                onClick={scrollToBottom}
                endIcon={<ArrowCircleDownIcon />}
              >
                <span>최신 채팅으로 이동</span>
              </Button>
            </Box>
          </Box>
          <Box
            id="admin-chat-input"
            sx={{
              flexGrow: 1,
              display: "flex",
              alignItems: "center",
            }}
            ref={inputChatRef}
            component="form"
            onSubmit={handleSubmit(onSubmit)}
            autoComplete="off"
          >
            {nicknameChange ? (
              <>
                <NicknameUpdate
                  nickname={nickname}
                  setNicknameChange={setNicknameChange}
                  changeAdminNickname={changeAdminNickname}
                />
              </>
            ) : (
              <>
                <Tooltip title="닉네임 변경">
                  <Box>
                    <IconButton
                      color="inherit"
                      onClick={() => {
                        setNicknameChange(true);
                      }}
                      edge="start"
                      sx={{ ml: "0px" }}
                    >
                      <ManageAccountsIcon sx={{ color: "#35463f" }} />
                    </IconButton>
                  </Box>
                </Tooltip>
                <TextField
                  inputRef={inputMsgRef}
                  inputProps={
                    props.userState.id === ""
                      ? {
                          readOnly: true,
                          enterKeyHint: "Send",
                          style: { padding: "0px 14px" },
                        }
                      : { enterKeyHint: "Send", style: { padding: "0px 14px" } }
                  }
                  type="search"
                  autoComplete="off"
                  sx={{
                    width: "100%",
                    color: "black",
                    "&::placeholder": { color: "gray" },
                  }}
                  placeholder={
                    props.userState.id === ""
                      ? "로그인 후 채팅에 참여하세요."
                      : "채팅 내용을 입력해주세요."
                  }
                  onKeyDown={(e: React.KeyboardEvent) => {
                    if (e.key === "Escape") fncResetQuote();
                  }}
                  {...register("msg", { required: true, maxLength: 3000 })}
                />
                <Button id="btn-admin-send-chat" type="submit" variant="text">
                  보내기
                </Button>
              </>
            )}
          </Box>
        </Stack>
        <Dialog
          open={openChatUserList}
          onClose={() => {
            setOpenChatUserList(false);
          }}
          sx={{
            "& .MuiDialog-container": {
              "& .MuiPaper-root": { width: "100%", minWidth: "50%" },
            },
          }}
        >
          <DialogTitle>
            <Stack
              direction="row"
              spacing={2}
              sx={{ display: "flex", alignItems: "center" }}
            >
              <Typography sx={{ fontSize: "1.2rem", fontWeight: "bold" }}>
                회원 접속자 목록
              </Typography>
              <TextField
                id="input-search-id"
                sx={{ width: "15rem" }}
                label="아이디"
                value={searchId}
                type="search"
                autoComplete="off"
                inputProps={{ enterKeyHint: "Enter" }}
                onChange={(e) => {
                  setSearchId(e.target.value);
                  if (e.target.value === "") {
                    setChatUserList(totalChatUserList);
                  } else {
                    setChatUserList(
                      totalChatUserList.filter((chatUser: any) =>
                        chatUser.userId.includes(e.target.value)
                      )
                    );
                  }
                }}
                size="small"
              />
              <Typography
                sx={{
                  fontSize: "0.75rem",
                  fontWeight: "400",
                  color: "00000090",
                }}
              >
                {chatUserList.length}명 접속중
              </Typography>
            </Stack>
          </DialogTitle>
          <DialogContent>
            <Stack
              direction="row"
              spacing={0}
              sx={{ width: "100%", height: gridHeight }}
            >
              <Box sx={{ width: "100%", height: "100%" }}>
                <DataGrid
                  apiRef={gridApi}
                  rows={chatUserList}
                  columns={columns}
                  initialState={{
                    pagination: {
                      paginationModel: {
                        pageSize: pageSize,
                      },
                    },
                    sorting: {
                      sortModel: [
                        {
                          field: "enter_time_stamp",
                          sort: "asc",
                        },
                      ],
                    },
                  }}
                  slots={{ pagination: CustomPagination }}
                  hideFooterSelectedRowCount
                  getRowId={(row) => row.userId + row.enter_time_stamp}
                  rowSelectionModel={selectedRow}
                  onRowSelectionModelChange={(newRowSelectionModel) => {
                    setSelectedRow(newRowSelectionModel);
                  }}
                  paginationModel={selectedPage}
                  onPaginationModelChange={(newPagenationModel) => {
                    setSelectedPage(newPagenationModel);
                  }}
                  onRowClick={(param) => handleRowSelected(param.row.userId)}
                />
              </Box>
              {selectedId !== "" ? (
                <Box
                  id="admin-private-chat-list"
                  sx={{ height: "100%", width: "100%", display: "flex" }}
                >
                  <Stack
                    direction="column"
                    spacing={0}
                    sx={{ height: "100%", width: "100%", display: "flex" }}
                  >
                    <Box
                      ref={privateListRef}
                      className="private-chat-list"
                      sx={{
                        height: "100%",
                        width: "100%",
                        display: "flex",
                        position: "relative",
                        overflowY: "scroll",
                        overflowX: "hidden",
                      }}
                    >
                      <ChatPrivate privateMessageList={privateMessages} />
                    </Box>
                    <Box
                      id="admin-private-chat-input"
                      sx={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        boxSizing: "border-box",
                      }}
                      ref={privateInputChatRef}
                      component="form"
                      onSubmit={privateHandleSubmit(onPrivateSubmit)}
                      autoComplete="off"
                    >
                      <TextField
                        inputRef={privateInputMsgRef}
                        inputProps={
                          props.userState.id === ""
                            ? {
                                readOnly: true,
                                enterKeyHint: "Send",
                                style: { padding: "0px 14px" },
                              }
                            : {
                                enterKeyHint: "Send",
                                style: { padding: "0px 14px" },
                              }
                        }
                        type="search"
                        autoComplete="off"
                        sx={{
                          width: "100%",
                          color: "black",
                          "&::placeholder": { color: "gray" },
                        }}
                        placeholder={
                          props.userState.id === ""
                            ? "로그인 후 채팅에 참여하세요."
                            : `To ${selectedId}: `
                        }
                        onKeyDown={(e: React.KeyboardEvent) => {
                          if (e.key === "Escape") fncResetQuote();
                        }}
                        {...privateRegister("msg", {
                          required: true,
                          maxLength: 3000,
                        })}
                      />
                      <Button
                        id="btn-admin-send-chat"
                        type="submit"
                        variant="text"
                      >
                        보내기
                      </Button>
                    </Box>
                  </Stack>
                </Box>
              ) : (
                <></>
              )}
            </Stack>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              onClick={() => {
                setOpenChatUserList(false);
                setSearchId("");
                setChatUserList(totalChatUserList);
                handleRowSelected("");
              }}
            >
              닫기
            </Button>
          </DialogActions>
        </Dialog>
        {/* Q&A 목록 */}
        <Dialog
          open={openQnAList}
          onClose={() => {
            setOpenQnAList(false);
          }}
          sx={{
            "& .MuiDialog-container": {
              "& .MuiPaper-root": { width: "100%" },
            },
          }}
        >
          <DialogTitle>
            <Stack
              direction="row"
              spacing={2}
              sx={{ display: "flex", alignItems: "center" }}
            >
              <Typography sx={{ fontSize: "1.2rem", fontWeight: "bold" }}>
                Q&A 목록
              </Typography>
            </Stack>
          </DialogTitle>
          <DialogContent>
            <List className="admin-qna-list" sx={{ paddingTop: "0px" }}>
              {broadQnaList.map(
                (obj: any, index: number) =>
                  obj.sk !== undefined && (
                    <div key={`qna${obj.sk}`}>
                      <Stack
                        direction="row"
                        spacing="2"
                        sx={{
                          width: "100%",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Box sx={{ width: "100%" }}>
                          <ListItem
                            disablePadding
                            sx={{ alignItems: "start", marginTop: "10px" }}
                          >
                            <Box
                              sx={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <Stack direction="row">
                                {/* Question Icon */}
                                <Box
                                  component="img"
                                  className="admin-question-icon"
                                  src="/images/icon-question.png"
                                />
                                <ListItemText
                                  className="admin-question-item"
                                  primary={
                                    <Typography
                                      paddingRight="10px"
                                      component="div"
                                      fontFamily="Noto Sans KR"
                                      fontWeight="700"
                                      fontSize="16px"
                                      fontStyle="normal"
                                      color="#111111"
                                      sx={{ wordBreak: "break-all" }}
                                    >
                                      {obj.qContent}
                                    </Typography>
                                  }
                                  secondary={
                                    <Typography
                                      component="div"
                                      fontFamily="Noto Sans KR"
                                      fontWeight="400"
                                      fontSize="13px"
                                      fontStyle="normal"
                                      color="#999999"
                                    >
                                      {obj.qUserName +
                                        " • " +
                                        dayjs(
                                          String(obj.qCreatedTimestamp)
                                        ).format("YYYY.MM.DD, HH:mm")}
                                    </Typography>
                                  }
                                />
                              </Stack>
                              <Button
                                disableRipple
                                sx={{
                                  "&:hover": { backgroundColor: "transparent" },
                                }}
                                onClick={() => {
                                  deleteQnaMessage(obj.aCreatedTimestamp);
                                }}
                              >
                                <DeleteForeverIcon sx={{ color: "red" }} />
                              </Button>
                            </Box>
                          </ListItem>
                          <ListItem
                            disablePadding
                            className="admin-answer-list-item"
                          >
                            <ListItemText
                              primary={
                                <Typography
                                  component="div"
                                  fontFamily="Noto Sans KR"
                                  fontWeight="400"
                                  fontSize="14px"
                                  fontStyle="normal"
                                  color="#111111"
                                >
                                  <AutoLink text={obj.aContent} />
                                </Typography>
                              }
                            />
                          </ListItem>
                        </Box>
                      </Stack>
                    </div>
                  )
              )}
            </List>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              onClick={() => {
                setOpenQnAList(false);
              }}
            >
              닫기
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
      <ChatBlock
        ref={chatBlockRef}
        broadSeq={props.channelInfo.broad_seq}
        callBack={callbackChatBlock}
      />
      <ChatUpdate ref={chatUpdateRef} updateChat={fncUpdate} />
      <Toast ref={toastRef} />
      <LoadingCircle loading={loading} />
    </>
  );
};

export default forwardRef(LiveChatModule);
